
import { defineComponent, nextTick, computed, onMounted, watch } from "vue";
import { useStore } from "vuex";
// import { useRoute } from "vue-router";
import { useI18n } from "vue-i18n/index";
import { Mutations, Actions } from "@/store/enums/StoreEnums";
import { initializeComponents } from "@/core/plugins/keenthemes";

export default defineComponent({
  name: "app",
  setup() {
    const store = useStore();
    // const router = useRouter();
    // const route = useRoute();
    const i18n = useI18n();

    const currentLanguage = computed(() => {
      return store.getters.getLanguage;
    });

    onMounted(() => {
      store.dispatch(Actions.VERIFY_AUTH);
      store.dispatch(Actions.GET_BANKS);
      store.dispatch(Actions.GET_PAYMENT_METHODS);
      store.dispatch(Actions.GET_SHIPPING_COMPANIES);
      store.dispatch(Actions.GET_CURRENCIES);
      store.dispatch(Actions.GET_CUSTOMERS);
      store.dispatch(Actions.GET_INVOICES);
      store.commit(
        Mutations.SET_LANG,
        localStorage.getItem("lang") || currentLanguage.value
      );
      i18n.locale.value = localStorage.getItem("lang") || currentLanguage.value;
      nextTick(() => {
        initializeComponents();
      });
      if (currentLanguage.value == "ar") {
        document.body.classList.add("rtl");
      } else {
        document.body.classList.remove("rtl");
      }
    });

    watch(currentLanguage, (newLanguage) => {
      if (newLanguage == "ar") {
        document.body.classList.add("rtl");
      } else {
        document.body.classList.remove("rtl");
      }
    });
  },
});
